import {Type} from 'react-bootstrap-table2-editor';

const tauxTvaColumnGenerate = (categorieTva, columnShow, headerSortingStyle, articleEditionDatatable, t, authParam) => {

    const columns = [];

    categorieTva.map((categorie)=>{
        let dataField = 'taux_'+categorie.name

        columns.push({
            dataField,
            text: t('taux_categorie_tva',{taxe:authParam.company.nomenclature_tgc})+' '+categorie.name+' *',
            hidden: (columnShow.includes(dataField)) ? false : true,
            formatter: (rowData) => rowData===null || rowData===undefined || rowData==='' ? '' : rowData+' %',
            sort: false,
            headerSortingStyle,
            editor: {
                type: Type.SELECT,
                options: [{value:'', label:'--'}, ...categorie.taux.map(value=>({value, label: value+'%'}))],
            },
            validator: (newValue, row, column, done) => {
                articleEditionDatatable(row,column.dataField,(newValue=='' ? null : +newValue),done,false,t,authParam)
                return {
                    async: true
                };
            }
        })
    })

    return columns;
};

export default tauxTvaColumnGenerate;